import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, ShieldCheck } from 'lucide-react';
import './TosModal.css';

const TosModal = ({ onClose }) => {
  return (
    <AnimatePresence>
      <motion.div 
        className="tos-modal-overlay"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        onClick={onClose}
      >
        <motion.div 
          className="tos-modal-content"
          initial={{ opacity: 0, y: 50, scale: 0.9 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 50, scale: 0.9 }}
          onClick={(e) => e.stopPropagation()}
        >
          <button className="tos-close-btn" onClick={onClose}>
            <X size={24} />
          </button>

          <div className="tos-header">
            <div className="tos-icon-circle">
              <ShieldCheck size={32} />
            </div>
            <h2>Terms of <span className="text-gradient">Service</span></h2>
            <p>Last Updated: April 2026</p>
          </div>

          <div className="tos-body">
            <section className="tos-section">
              <h3>1. Service Nature</h3>
              <p>ShoczTweaks provides remote PC optimization services via AnyDesk or similar remote desktop software. By purchasing, you grant Shocz permission to access your system and modify registry settings, system files, and hardware configurations.</p>
            </section>

            <section className="tos-section">
              <h3>2. No Refunds</h3>
              <p>Due to the digital nature of the service and the manual time spent on every optimization, <strong>all sales are final</strong>. Once the optimization process has begun, no refunds will be issued under any circumstances.</p>
            </section>

            <section className="tos-section">
              <h3>3. Liability Disclaimer</h3>
              <p>While all tweaks are tested and safe, hardware varies. ShoczTweaks is <strong>not responsible</strong> for any physical hardware failure, data loss, or OS instability that may occur after the service. You optimize your system at your own risk.</p>
            </section>

            <section className="tos-section">
              <h3>4. Stability Guarantee</h3>
              <p>We guarantee that our tweaks are stable on functional hardware. If your system was unstable or crashing before the service due to hardware defects, our service will not fix those underlying issues.</p>
            </section>

            <section className="tos-section">
              <h3>5. Software & Licenses</h3>
              <p>We do not provide licenses for paid software. Any software used during the optimization is either open-source, free-to-use, or must be owned by the customer.</p>
            </section>
          </div>

          <div className="tos-footer">
            <button className="tos-understand-btn" onClick={onClose}>I Understand</button>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default TosModal;
